import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import { FormsPaymentBranchForm } from '../Forms/FormsPaymentBranch.form';

export const BranchesPaymentActions = ({
  fn = {
    handler: () => ({}),
    handlerSelected: () => ({}),
    selected: {},
  },
  modal = {
    form: {},
    handler: () => ({}),
    loading: false,
    submit: () => ({}),
    visible: false,
  },
}) => {
  return (
    <Modal
      cancelText="Cancelar"
      centered
      destroyOnClose
      onCancel={() => {
        fn.handlerSelected({});
        modal.handler(false);
        modal.form.resetFields();
      }}
      onOk={() => modal.form.submit()}
      okText={fn.selected?.id ? 'Actualizar' : 'Registrar'}
      okButtonProps={{
        loading: modal.loading,
      }}
      title={
        fn.selected?.id
          ? 'Actualizar Forma de Pago de Sucursal'
          : 'Registrar Forma de Pago de Sucursal'
      }
      visible={modal.visible}
    >
      <FormsPaymentBranchForm formRef={modal.form} onSubmit={modal.submit} />
    </Modal>
  );
};

BranchesPaymentActions.propTypes = {
  fn: PropTypes.any.isRequired,
  modal: PropTypes.shape({
    form: PropTypes.object,
    handler: PropTypes.func,
    loading: PropTypes.bool,
    submit: PropTypes.func,
    visible: PropTypes.bool,
  }),
};
